import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class AuthParametersActions {
    static SET_CALLBACK = '[Auth-Parameters]: Set callback';
    static RESET = '[Auth-Parameters]: Reset';

    setCallback(callback: string): RidangoReduxAction {
        return {
            type: AuthParametersActions.SET_CALLBACK,
            payload: callback,
        };
    };

    reset(): RidangoReduxAction {
        return {
            type: AuthParametersActions.RESET,
        };
    };
}
